import qs from 'qs'

import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

interface SearchInboxProps {
  keyword: string
  startCreatedDate: string
  endCreatedDate: string
  startModifiedDate: string
  endModifiedDate: string
  page: number
  size: number
  sort: string
  isRead?: string
  pageable: object
}

export const searchAllInbox = async (params: SearchInboxProps) => {
  try {
    const queryParams = qs.stringify(
      {
        keyword: params.keyword,
        startCreatedDate: params.startCreatedDate,
        endCreatedDate: params.endCreatedDate,
        startModifiedDate: params.startModifiedDate,
        endModifiedDate: params.endModifiedDate,
        page: params.page,
        size: params.size,
        sort: [params.sort],
        pageable: {},
      },
      { arrayFormat: 'repeat' },
    )

    const response = await useAxios.post(
      `${DND_SERVICE}/v1/notification/user/search?${queryParams}`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllBellNotification = async (params: SearchInboxProps) => {
  try {
    const queryParams = qs.stringify(
      {
        keyword: params.keyword,
        startCreatedDate: params.startCreatedDate,
        endCreatedDate: params.endCreatedDate,
        startModifiedDate: params.startModifiedDate,
        endModifiedDate: params.endModifiedDate,
        page: params.page,
        size: params.size,
        sort: [params.sort],
        isRead: 'false',
        pageable: {},
      },
      { arrayFormat: 'repeat' },
    )

    const response = await useAxios.post(
      `${DND_SERVICE}/v1/notification/user/search?${queryParams}`,
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const readNotification = async (notificationId: number) => {
  try {
    const response = await useAxios.put(
      `${DND_SERVICE}/v1/notification/mark-as-read/${notificationId}`,
    )

    return response
  } catch (error) {
    console.error('Error marking as read', error)
    throw error
  }
}
